import { render, staticRenderFns } from "./cfsBatchUpdate.vue?vue&type=template&id=a9cdb980&"
import script from "./cfsBatchUpdate.vue?vue&type=script&lang=js&"
export * from "./cfsBatchUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports